module.exports = __webpack_public_path__ + "static/media/member.5d444ca9.png";